import { t } from "i18next";
import {
  IWebsiteBuilderElementBase,
  IWebsiteBuilderElementDataBase,
  IWebsiteBuilderElementDesignStyles,
  TWebsiteBuilderElement,
} from "./websiteBuilderElement";

export enum WebsiteBuilderHeadingLevel {
  ONE = 1,
  TWO,
  THREE,
  FOUR,
  FIVE,
  SIX,
}

export interface IWebsiteBuilderHeadingSettings {
  level: WebsiteBuilderHeadingLevel;
  text: string;
}

export interface IWebsiteBuilderHeadingData extends IWebsiteBuilderElementDataBase {
  type: "heading";
  settings: IWebsiteBuilderHeadingSettings;
}

export interface IWebsiteBuilderHeading extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderHeadingData;
}

export function isWebsiteBuilderHeading(node: TWebsiteBuilderElement): node is IWebsiteBuilderHeading {
  return node?.element?.type === "heading";
}

export function generateDefaultHeading(): IWebsiteBuilderHeading {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "heading",
      position: { x: 0, y: 0 },
      dimensions: { width: 150, height: 50 },
      zIndex: null,
      settings: {
        level: WebsiteBuilderHeadingLevel.ONE,
        text: t("Heading"),
      },
    },
  };
}

export function generateHeadingDesignStyles(): IWebsiteBuilderElementDesignStyles {
  return {
    className: "website-builder-heading",
    style: {},
  };
}
